import React, { useState } from 'react';
import classNames from 'classnames/bind';
import config from 'config';
import _isEmpty from 'lodash/isEmpty';
import { useQuery } from 'react-query';
import { StringParam, useQueryParams, NumberParam } from 'use-query-params';
import Input from '../../components/Input/Input';
import styles from './assets/styles.scss';
import apiClient from '../../helpers/apiClient';
import Detail from '../../components/Detail/Detail';
import useDebouncedCallback from '../../helpers/useDebouncedCallback';
import Loader from '../../components/Loader3/Loader';
import { games } from '../../games/config';
import Default from './layouts/Default';
import Baccarat from './layouts/Baccarat';
import CoinBattles from './layouts/CoinBattles';
import Blackjack from './layouts/Blackjack';

const cx = classNames.bind(styles);

const getResults = async (txId, gameId, gameCode) => {
  let payload;
  if (gameId && gameCode) {
    payload = { gameId, game: gameCode };
  } else {
    payload = { txid: txId };
  }
  const { data } = await apiClient().get('/v1/fairness/search', { params: { asset: config.asset, ...payload } });
  return data[0] || data;
};

const FairnessCalculation = () => {
  const [query, setQuery] = useQueryParams({
    txId: StringParam,
    gameId: NumberParam,
    gameCode: StringParam,
  });
  const { txId, gameId, gameCode } = query;
  const [inputValue, setInputValue] = useState(txId || '');
  const { data = {}, isLoading, remove: resetData } = useQuery(
    ['fairness', txId, gameCode, gameId],
    () => getResults(txId, gameId, gameCode),
    {
      enabled: !!txId || (!!gameId && !!gameCode),
    }
  );

  useDebouncedCallback(
    () => {
      if (inputValue) {
        if (query.gameId && query.gameCode) {
          setQuery({ gameId: null, gameCode: null });
        }
      } else {
        if (!query.gameId && !query.gameCode) {
          resetData();
        }
        if (query.gameId && !query.gameCode) {
          resetData();
          setQuery({ gameId: null });
        }
      }
      setQuery({ txId: inputValue });
    },
    inputValue,
    1000
  );

  function getLayoutComponent() {
    switch (data.game_code) {
      case 'cfBattle':
        return <CoinBattles data={data} gameId={gameId} setGameId={newGameId => setQuery({ gameId: newGameId })} />;
      case 'baccarat':
        return <Baccarat data={data} />;
      case 'blackjack':
        return <Blackjack data={data} />;
      default:
        return <Default data={data} />;
    }
  }
  function getContent() {
    if (isLoading) {
      return <Loader />;
    }
    if (txId && _isEmpty(data)) {
      return (
        <span className={cx('small', 'retry')}>
          Round Seed hasn't revealed yet. <br /> Please try again later
        </span>
      );
    }
    if (data.game_code === 'lotto') {
      return <span className={cx('small', 'bitto')}>Please check on Bitto Page</span>;
    }
    return (
      <>
        <h6>Calculation Breakdown</h6>
        <Detail
          contentClassName={cx('detail-content')}
          className={cx('detail')}
          label="Game"
          content={games[data.game_code]?.label}
        />
        {getLayoutComponent()}
      </>
    );
  }

  return (
    <div className={cx('calculator')}>
      <h3>Fairness Calculation</h3>
      <span className={cx('subtitle')}>Please enter your Bet Transaction ID to check the final game result.</span>
      <Input
        className={cx('input-container')}
        label="Bet TxID"
        value={inputValue}
        onChange={newValue => setInputValue(newValue)}
        placeholder="Enter Your TxID"
      />
      {getContent()}
    </div>
  );
};

export default FairnessCalculation;
